import {
  REQUEST_CHECK_LOGIN,
  REQUEST_LOGOUT
} from './mutation-types';

import axiosInst from '@/utility/axiosInst';

export default {
  requestLogin({}, payload) {
    const { username, pwd, isSaveUsername, isLoginPage } = payload
    return axiosInst.springAxiosInst.post("/account/login", { username, pwd, isSaveUsername })
      .then((res) => {
        if (res.data.result) {
          localStorage.setItem('accountName', res.data.name)
          if (res.data.username) {
            localStorage.setItem('usernameSave', res.data.username)
          }
          return isLoginPage
        }
      })
      .catch(error => {
        console.error('Error during request:', error);
      })
  },

  requestNonUserLogin({}, payload) {
    const { nonUserName, phoneNum, orderNum } = payload
    return axiosInst.springAxiosInst.post("/account/nonUserLogin", { nonUserName, phoneNum, orderNum })
      .then((res) => {
        console.log(res.data)
        if (res.data.result) {
          localStorage.setItem('accountName', res.data.name)
          if (res.data.username) {
            localStorage.setItem('usernameSave', res.data.username)
          }
        }
        return res.data.result
      })
  },

  requestKakaoOauthRedirectUrl({}) {
    return axiosInst.springAxiosInst.get("/oauth/kakao")
      .then((res) => {
        window.location.href = res.data
      })
  },

  requestNaverOauthRedirectUrl({}) {
    return axiosInst.springAxiosInst.get("/oauth/naver")
      .then((res) => {
        window.location.href = res.data
      })
  },

  requestCheckNaverAccount({}, payload) {
    return axiosInst.springAxiosInst.get("/oauth/naver-check-account", { params: { code: payload } })
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        console.log(error)
      })
  },

  requestNaverLogin({}, code) {
    return axiosInst.springAxiosInst.get("/oauth/naver-login", { params: { code: code } })
      .then((res) => {
        if (res.data.result) {
          localStorage.setItem('accountName', res.data.name)
        } else {
          alert('아이디 혹은 비밀번호가 틀렸습니다.')
        }
      })
      .catch((error) => {
        console.log(error)
      })
  },

  requestNaverSignup({}, code) {
    return axiosInst.springAxiosInst.get("/oauth/naver-signup", { params: { code: code } })
      .then((res) => {
        if (res.data.result) {
          localStorage.setItem('accountName', res.data.name)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  },

  requestNaverOauthConnectRedirectUrl({}) {
    return axiosInst.springAxiosInst.get("/oauth/naver-connect")
      .then((res) => {
        window.location.href = res.data
      })
  },

  requestNaverConnect({}, code) {
    return axiosInst.springAxiosInst.get("/oauth/naver-connect-account", { params: { code: code } })
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        console.log(error)
      })
  },

  requestCheckKakaoAccount({}, payload) {
    return axiosInst.springAxiosInst.get("/oauth/kakao-check-account", { params: { code: payload } })
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        console.log(error)
      })
  },

  requestKakaoLogin({}, code) {
    return axiosInst.springAxiosInst.get("/oauth/kakao-login", { params: { code: code } })
      .then((res) => {
        if (res.data.result) {
          localStorage.setItem('accountName', res.data.name)
        } else {
          alert('아이디 혹은 비밀번호가 틀렸습니다.')
        }
      })
      .catch((error) => {
        console.log(error)
      })
  },

  requestKakaoOauthConnectRedirectUrl({}) {
    return axiosInst.springAxiosInst.get("/oauth/kakao-connect")
      .then((res) => {
        window.location.href = res.data
      })
  },

  requestKakaoConnect({}, code) {
    return axiosInst.springAxiosInst.get("/oauth/kakao-connect-account", { params: { code: code } })
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        console.log(error)
      })
  },

  requestKakaoSignup({}, code) {
    return axiosInst.springAxiosInst.get("/oauth/kakao-signup", { params: { code: code } })
      .then((res) => {
        if (res.data.result) {
          localStorage.setItem('accountName', res.data.name)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  },

  requestCheckUsername({}, username) {
    return axiosInst.springAxiosInst.get("/account/check-duplicate", { params: { username: username } })
      .then((res) => {
        return res.data
      })
  },

  requestSignup({}, payload) {
    return axiosInst.springAxiosInst.post("/account/signup", payload)
      .then((res) => {
        if (res.data.result) {
          localStorage.setItem('accountName', res.data.name)
          return res.data.result
        }
      })
      .catch((error) => {
        console.log(error)
      })
  },

  requestCheckLogin({commit}) {
    return axiosInst.springAxiosInst.get("/account/check-login")
      .then((res) => {
        commit(REQUEST_CHECK_LOGIN, res.data)
      })
  },

  // requestCheckLogin({commit}) {
  //   return axiosInst.springAxiosInst.get("/account/check-login", {
  //     headers: { 'Accept': 'application/json' }
  //   }).then((res) => {
  //     commit(REQUEST_CHECK_LOGIN, res.data)
  //   })
  // },

  requestLogout({commit}) {
    return axiosInst.springAxiosInst.get("/account/logout")
      .then(
        commit(REQUEST_LOGOUT),
        localStorage.removeItem("accountName")
      )
  },

  requestCheckConnect({}) {
    return axiosInst.springAxiosInst.get("/account/check-connect")
      .then((res) => {
        return res.data
      })
  },

  requestChangePassword({}, payload) {
    return axiosInst.springAxiosInst.post("/account/change-password", payload)
      .then((res) => {
        return res.data
      })
  },

  requestRegisterReturnBank({}, payload) {
    return axiosInst.springAxiosInst.post("/account/register-return-bank", payload)
      .then((res) => {
        return res.data
      })
  },

  requestReturnBankInfo({}) {
    return axiosInst.springAxiosInst.get("/account/return-bank-info")
      .then((res) => {
        return res.data
      })
  },

  requestDeleteReturnBank({}) {
    return axiosInst.springAxiosInst.get("/account/delete-return-bank")
    .then((res) => {
      return res.data
    })
  },

  requestAccountInfo({}) {
    return axiosInst.springAxiosInst.get("/account/get-account-info")
    .then((res) => {
      return res.data
    })
  },

  requestChangeAccountInfo({}, payload) {
    return axiosInst.springAxiosInst.post("/account/change-account-info", payload)
    .then((res) => {
      return res.data
    })
  },

  requestDeleteAccount({commit}, payload) {
    return axiosInst.springAxiosInst.post("/account/delete-account", payload)
    .then((res) => {
      if (res.data.result == 'true') {
        commit(REQUEST_LOGOUT)
        localStorage.removeItem("accountName")
      }
      return res.data
    })
  }
}